import PropTypes from 'prop-types'

import { Box, Paper, Typography } from '@mui/material'

import { ReactComponent as DownloadSimple } from '../../../../assets/icons/download-simple.svg'

import useStyles from './styles'

const DownloadBox = ({ infoText, mbSize, buttonText, buttonUrl }) => {
  const classes = useStyles()

  return (
    <Paper
      elevation={1}
      component="a"
      href={buttonUrl}
      download
      className={classes.downloadBox}
    >
      <Typography
        variant="body2"
        component="span"
        className={classes.downloadBoxInfoText}
      >
        {infoText}
      </Typography>
      <Box component="p" className={classes.downloadBoxRightContent}>
        {mbSize ? (
          <Typography
            component="span"
            variant="body2"
            className={classes.downloadBoxMbSize}
          >
            {mbSize} MB
          </Typography>
        ) : null}
        {buttonUrl === null ? (
          // NOTE: temporary solution untill CTT provide the manuals.
          <span className={classes.downloadBoxRightContentOnlyText}>
            Próximamente
          </span>
        ) : (
          <Box component="span" className={classes.downloadBoxRightTextWrapper}>
            <DownloadSimple />
            {buttonText}
          </Box>
        )}
      </Box>
    </Paper>
  )
}

DownloadBox.propTypes = {
  infoText: PropTypes.string,
  mbSize: PropTypes.number,
  buttonText: PropTypes.string,
  buttonUrl: PropTypes.string,
}

export default DownloadBox
